import React, { useState } from "react";
import DTPicker from "../DateTime/DTPicker";
import { Alert, CircularProgress, Snackbar } from "@mui/material";
import { sendData } from "../../Config/FirebaseMethod";
import axios from "axios";

const MeetingForm = () => {
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [open, setOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(false);
  const [alertSeverity, setAlertSeverity] = useState("success");
  const [alertMessage, setAlertMessage] = useState("");
  const [fullname, setName] = useState("");
  const [purpose, setPurpose] = useState("");
  const [email, setEmail] = useState("");
  const [dateTime, setDateTime] = useState("");
  const [number, setNumber] = useState("");
  const [social, setSocial] = useState("");
  const [category, setCategory] = useState("user");
  const BookingKey = process.env.REACT_APP_BOOKING_KEY;

  let meeting = () => {
    setIsLoading(true);
    sendData(
      {
        fullname,
        email,
        purpose,
        dateTime,
        number,
        social,
        category,
      },
      "Booking"
    )
      .then((success) => {
        setIsLoading(false);
        setAlertSeverity("success");
        setAlertMessage(success);
        setOpen(true);
        setError(false);
      })
      .catch((error) => {
        setError(true);
        setIsLoading(false);
        setAlertSeverity("error");
        setAlertMessage(error);
      });
  };

  const CountryOptions = [
    { value: "webdevelopment", label: "Web Development" },
    { value: "webdesigning", label: "Web Designing" },
    { value: "wordpress", label: "Wordpress Website Development" },
    { value: "ecommerce", label: "Ecommerce Website Development" },
    { value: "webapplication", label: "Web Application Development" },
    { value: "mobileapp", label: "Mobile App Development" },
    { value: "webfirebase", label: "Web Application With Firebase" },
    { value: "guidance", label: "Guidance For Developer" },
    { value: "Other", label: "Other" },
  ];

  const handleDateChange = (date) => {
    setSelectedDate(date);
    const formattedDate = date.toString();
    setDateTime(formattedDate);
  };

  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  let handleSubmit = (e) => {
    e.preventDefault();
    meeting();
    axios
      .post(BookingKey, {
        name: fullname,
        email: email,
      })
      .then((response) => {
        console.log("Email sent successfully");
        // Handle success, e.g., show a success message
      })
      .catch((error) => {
        console.error("Email send failed", error);
        // Handle error, e.g., show an error message
      });
  };

  return (
    <React.Fragment>
      <div className="container mt-5 mb-5">
        <form onSubmit={handleSubmit}>
          <div className="row">
            <div className="col-lg-6">
              <div className="mb-3">
                <label for="exampleInputEmail1" className="form-label">
                  Your Full Name
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="exampleInputEmail1"
                  aria-describedby="emailHelp"
                  required
                  onChange={(e) => setName(e.target.value)}
                />
              </div>

              <div className="mb-3">
                <label className="form-label" htmlFor="country">
                  Purpose Of Meeting
                </label>
                <select
                  className="form-select form-control"
                  name="Country"
                  onChange={(e) => setPurpose(e.target.value)}
                >
                  <option value="" className="option-select">
                    Select Purpose Of Meeting
                  </option>
                  {CountryOptions.map((option) => (
                    <option
                      key={option.value}
                      value={option.value}
                      className="option-select"
                    >
                      {option.label}
                    </option>
                  ))}
                </select>
              </div>

              <div className="mb-3">
                <label for="exampleInputEmail1" className="form-label">
                  Your Contact Number
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="exampleInputEmail1"
                  aria-describedby="emailHelp"
                  required
                  onChange={(e) => setNumber(e.target.value)}
                />
              </div>
            </div>
            <div className="col-lg-6">
              <div className="mb-3">
                <label for="exampleInputEmail1" className="form-label">
                  Your Email Address
                </label>
                <input
                  type="email"
                  className="form-control"
                  id="exampleInputEmail1"
                  aria-describedby="emailHelp"
                  required
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>

              <div className="mb-3">
                <label for="exampleInputEmail1" className="form-label">
                  Your Date & Time
                </label>
                <DTPicker onDateChange={handleDateChange} />
              </div>

              <div className="mb-3">
                <label for="exampleInputEmail1" className="form-label">
                  Your Any Social Media Handle
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="exampleInputEmail1"
                  aria-describedby="emailHelp"
                  required
                  onChange={(e) => setSocial(e.target.value)}
                />
              </div>
            </div>
          </div>
          <p className="text-secondary">
            Please fill all the details in this form carefully and then after
            clicking the button and submitting the form if you get the
            confirmation email then your meeting is booked.
          </p>
          <button type="submit" className="btn-subscribe">
            {isLoading ? <CircularProgress /> : "Book IT"}
          </button>
        </form>
        <Snackbar
          open={open}
          autoHideDuration={6000}
          onClose={handleSnackbarClose}
        >
          <Alert severity={alertSeverity} sx={{ width: "100%" }}>
            {alertMessage}
          </Alert>
        </Snackbar>
      </div>
    </React.Fragment>
  );
};

export default MeetingForm;
